import { render, staticRenderFns } from "./SuperUserOrgs.vue?vue&type=template&id=3242834c&"
import script from "./SuperUserOrgs.vue?vue&type=script&lang=js&"
export * from "./SuperUserOrgs.vue?vue&type=script&lang=js&"
import style0 from "./SuperUserOrgs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports